export enum SlotPayoutType {
  Loss = 0,
  LowWin = 1,
  MedWin = 2,
  BigWin = 3,
  JackpotWin = 4,
}

export enum SlotReelSymbol {
  Random = 0,
  Health = 1,
  Bodyguard = 2,
  HelperBot = 3,
  Cash = 4,
  Bullets = 5,
  Crate = 6,
  MafiaToken = 7,
  Keys = 8,
  OGNFT = 9,
  Diamonds = 10,
  Jackpot7 = 11,
}

export enum SlotMachineBetStatus {
  NOT_REQUESTED,
  REQUESTED,
  FINISHING,
  SPINNING,
  FINISHED,
}
